import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import { HealthSystemDomainSettingsResultTranslationViewModel } from '../api/HealthSystemApi';

interface LanguageSelectProps {
  value: string;
  translations: HealthSystemDomainSettingsResultTranslationViewModel[];
  onLanguageChange: (value: string) => void;
  disabled?: boolean;
  cssClass?: string;
  fullWidth?: boolean;
  labelText?: string;
}

const LanguageSelect = ({
  value,
  onLanguageChange,
  translations,
  cssClass,
  fullWidth,
  labelText,
  disabled
}: LanguageSelectProps) => {
  const { t } = useTranslation();

  const handleLanguageChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;

    //callback
    onLanguageChange && onLanguageChange(value);
  };

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} disabled={disabled}>
      <InputLabel id="lang-lbl">{labelText || t('f-usr-lang')}</InputLabel>
      <Select labelId="lang-lbl" id="lang-select" value={value} onChange={handleLanguageChange}>
        {translations.map((trans) => (
          <MenuItem value={trans.isoCode} key={trans.id}>{`${trans.language} (${trans.isoCode})`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelect;
